// extracted by mini-css-extract-plugin
export default {"container":"ColorPicker_container__hvuUI"};